import { IconChevronsLeft, IconChevronsRight } from "@/assets/icons";
import { toNumber } from "@/utils/number";
import { Pagination as MuiPagination, PaginationItem, Stack, styled } from "@mui/material";
import { FC } from "react";

type Props = {
  totalPage: number;
  page: number;
  onChangePage: (page: number) => void;
};

export const ModalPagination: FC<Props> = ({ totalPage, page, onChangePage }) => {
  return (
    <Stack direction="row" alignItems="center" gap={2.5}>
      <StyledPagination
        page={page}
        count={totalPage}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        renderItem={(item) => {
          const handleClick = () => {
            let newPage = page;
            if (item.type === "first") {
              newPage = 1;
            } else if (item.type === "previous") {
              newPage = Math.max(1, page - 1);
            } else if (item.type === "next") {
              newPage = Math.min(totalPage, page + 1);
            } else if (item.type === "last") {
              newPage = totalPage > 0 ? totalPage : 1;
            } else if (item.type === "page" && item.page !== null && item.page !== undefined) {
              newPage = toNumber(item.page);
            }
            onChangePage(newPage);
          };

          return <PaginationItem {...item} onClick={handleClick} slots={{ first: IconChevronsLeft, last: IconChevronsRight }} />;
        }}
      />
    </Stack>
  );
};

const StyledPagination = styled(MuiPagination)(() => ({
  "& .MuiPaginationItem-root": {
    border: "2px solid #cfd4d9",
    borderRadius: 8,
    minWidth: 40,
    height: 40,
    fontSize: 14,
    fontWeight: 500,
    color: "#4a4a4a",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
  },
  "& .MuiPaginationItem-root.Mui-selected": {
    backgroundColor: "#C34A24",
    color: "#fff",
    border: "none",
    "&:hover": {
      backgroundColor: "#C34A24",
    },
  },
  "& .MuiPaginationItem-ellipsis": {
    border: "2px solid transparent",
    minWidth: 48,
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    fontWeight: 500,
    color: "#4a4a4a",
  },
  "& .MuiPaginationItem-root.Mui-disabled": {
    border: "2px solid transparent",
    backgroundColor: "#f2f2f2",
    color: "#b0b0b0",
    pointerEvents: "none",
  },
}));
